import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCoursePermission, AI_VEX_COURSE_ID } from '../../hooks/useCoursePermission';

const AiVexRedirectPage: React.FC = () => {
  const navigate = useNavigate();
  const permission = useCoursePermission(AI_VEX_COURSE_ID);

  if (permission.loading) {
    return (
      <div className="h-screen w-screen bg-[#0c0c0e] flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-700 border-t-purple-500"></div>
          <span className="text-gray-500 font-mono text-sm">CHECKING PERMISSION...</span>
        </div>
      </div>
    );
  }

  if (!permission.hasAccess) {
    return (
      <div className="h-screen w-screen bg-[#0c0c0e] flex items-center justify-center">
        <div className="flex flex-col items-center gap-6 max-w-md text-center px-6">
          <div className="text-6xl">🚫</div>
          <h1 className="text-2xl font-bold text-white">无访问权限</h1>
          <p className="text-gray-400">
            您没有访问 AI VEX 页面的权限。请联系管理员获取相关课程的学习权限。
          </p>
          <button
            onClick={() => navigate('/student/portal')}
            className="px-6 py-3 rounded-lg bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-medium transition-all"
          >
            返回课程列表
          </button>
        </div>
      </div>
    );
  }

  const hostname = window.location.hostname;
  let vexUrl: string;
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    vexUrl = 'http://localhost:4180';
  } else {
    vexUrl = `https://vex.${hostname}`;
  }

  window.location.href = vexUrl;
  
  return (
    <div className="h-screen w-screen bg-[#0c0c0e] flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-700 border-t-purple-500"></div>
        <span className="text-gray-500 font-mono text-sm">REDIRECTING TO AI VEX...</span>
      </div>
    </div>
  );
};

export default AiVexRedirectPage;
